export default "__VITE_ASSET__Be3754$___"